const palette = {
  mode: "light",

  primary: {
    main: "#0b1f1a",
  },

  secondary: {
    main: "#c9a24d",
  },

  background: {
    default: "#f5f5f3",
    paper: "#ffffff",
  },

  text: {
    primary: "#1c1c1c",
    secondary: "#6b6b6b",
  },
};

export default palette;
